<template>
  <ul class="main-menu">
    <li>
      <span class="root">მოდულები</span>
      <ul>
        <li>
          <router-link
            :to="{
              name: 'section',
              params: {
                id: 1,
              },
            }"
            >მოდული 1: თანასწორობის უფლება და დისკრიმინაციის
            აკრძალვა</router-link
          >
        </li>
        <li>
          <router-link
            :to="{
              name: 'section',
              params: {
                id: 7,
              },
            }"
            >მოდული 2: დისკრიმინაციის ფორმები და დისკრიმინაციის წახალისება</router-link
          >
        </li>
        <li>
          <router-link
            :to="{name: 'section', params: { id: 26 }}">მოდული 3: დისკრიმინაცია ცალკეული ჯგუფების მიმართ</router-link>
        </li>
        <li>
          <router-link
            :to="{name: 'section', params: { id: 36 }}">მოდული 4: დისკრიმინაციის ფაქტებზე რეაგირება</router-link>
        </li>
      </ul>
    </li>
    <li>
      <router-link :to="{ name: 'aboutCourse' }">კურსის შესახებ</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'purpose' }">კურსის აქტუალურობა</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'glossary' }">ტერმინთა განმარტება</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'references' }"
        >გამოყენებული რესურსები</router-link
      >
    </li>
    <li>
      <router-link :to="{ name: 'contact' }">კონტაქტი</router-link>
    </li>
  </ul>
</template>

<script>
export default {};
</script>

<style>
ul.main-menu li a.router-link-active {
  position: relative;
  /* border-bottom: solid 2px red */
}
ul.main-menu li a.router-link-active:before {
  content: " ";
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #afbce9;
}
ul.main-menu {
  position: relative;
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-block;
}
ul.main-menu li {
  display: inline-block;
}
ul.main-menu li a {
  color: inherit;
  text-decoration: none;
  padding: 1rem;
  display: block;
}
ul.main-menu li .root {
  padding: 1rem;
  display: block;
  cursor: pointer;
}
ul.main-menu li a:hover,
ul.main-menu li .root:hover {
  color: #4460ca;
}
ul.main-menu li:hover ul {
  display: block;
}
ul.main-menu ul {
  position: absolute;
  top: 100%;
  text-align: left;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 99;
  padding: 1rem 0;
  display: none;
}
ul.main-menu ul:before {
  content: " ";
  display: block;
  width: 200vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #24387f;
  z-index: -1;
  transform: translateX(-100vw);
}
ul.main-menu ul:after {
  content: " ";
  display: block;
  position: absolute;
  top: -6px;
  left: 10%;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #24387f;
}
ul.main-menu ul li {
  display: block;
}
ul.main-menu ul li a {
  color: #fff;
  font-weight: bolder;
}
ul.main-menu ul li a:hover {
  color: #afbce9;
}
ul.main-menu li ul li a.router-link-active:before {
  display: none;
}
</style>